// extracted by mini-css-extract-plugin
module.exports = {"container":"EntityNavigationScrollable_container__Gdebk","title":"EntityNavigationScrollable_title__zPucW","links":"EntityNavigationScrollable_links__iM84B"};